<dx-button type="normal"
           stylingMode="text"
           icon="refresh"
           [text]="'inventory.priceCalculation.reload' | translate"
           [disabled]="!loaded"
           (onClick)="reload()"></dx-button>
<dx-button *ngIf="canCalcInternal()"
           type="normal"
           stylingMode="text"
           icon="money"
           [text]="'inventory.priceCalculation.internalQuery' | translate"
           [disabled]="!loaded || isCalculatingInternal"
           (onClick)="calcInternal()"></dx-button>
<dx-button *ngIf="canQueryGpt()"
           type="normal"
           stylingMode="text"
           icon="search"
           [text]="'inventory.priceCalculation.gptQuery' | translate"
           [disabled]="!loaded || isQuerying"
           (onClick)="queryGpt()"></dx-button>
<dx-button *ngIf="canQueryGeizhals()"
           type="normal"
           stylingMode="text"
           icon="chart"
           [text]="'inventory.priceCalculation.geizhalsQuery' | translate"
           [disabled]="!loaded || isQueryingGeizhals"
           (onClick)="queryGeizhals()"></dx-button>
<div *ngIf="canCalcRg()"
     class="rg-calc">
  <h5>{{ 'inventory.priceCalculation.rgForm.title' | translate }}</h5>
  <div class="rg-calc__grid">
    <div class="rg-calc__field">
      <label>{{ 'inventory.priceCalculation.rgForm.acquisitionPrice' | translate }}</label>
      <dx-number-box [value]="$any(rgFormData.acquisition_price)"
                     (valueChange)="rgFormData.acquisition_price = $event"
                     format="#,##0.## €"
                     [min]="0"
                     [showClearButton]="true"></dx-number-box>
    </div>

    <div class="rg-calc__field">
      <label>{{ 'inventory.priceCalculation.rgForm.usefulLifeYears' | translate }}</label>
      <dx-number-box [value]="$any(rgFormData.useful_life_years)"
                     (valueChange)="rgFormData.useful_life_years = $event"
                     format="#0"
                     [min]="1"
                     [max]="99"></dx-number-box>
    </div>

    <div class="rg-calc__field">
      <label>{{ 'inventory.priceCalculation.rgForm.residualEndPercent' | translate }}</label>
      <dx-number-box [(value)]="rgFormData.residual_end_percent"
                     format="#0'%'"
                     [min]="0"
                     [max]="100"></dx-number-box>
    </div>

    <div class="rg-calc__field">
      <label>{{ 'inventory.priceCalculation.rgForm.valuationDate' | translate }}</label>
      <dx-date-box [(value)]="rgFormData.valuation_date"
                   type="date"
                   displayFormat="dd.MM.yyyy"></dx-date-box>
    </div>

    <div class="rg-calc__field">
      <label>{{ 'inventory.priceCalculation.rgForm.acquisitionDate' | translate }}</label>
      <dx-date-box [value]="$any(rgFormData.acquisition_date)"
                   (valueChange)="rgFormData.acquisition_date = $any($event)"
                   type="date"
                   displayFormat="dd.MM.yyyy"></dx-date-box>
    </div>

    <div class="rg-calc__field">
      <label>{{ 'inventory.priceCalculation.rgForm.condition' | translate }}</label>
      <dx-select-box [(value)]="rgFormData.condition"
                     [items]="(inventoryService.conditions$ | async) ?? []"
                     valueExpr="key"
                     displayExpr="label"></dx-select-box>
    </div>

    <div class="rg-calc__field">
      <label>{{ 'inventory.priceCalculation.rgForm.accessories' | translate }}</label>
      <dx-select-box [(value)]="rgFormData.accessories_factor"
                     [items]="accessoriesOptions"
                     valueExpr="value"
                     displayExpr="label"></dx-select-box>
    </div>

    <div class="rg-calc__field">
      <label>{{ 'inventory.priceCalculation.rgForm.repairs' | translate }}</label>
      <dx-number-box [(value)]="rgFormData.repairs_factor"
                     format="#0.#"
                     [min]="0"
                     [step]="0.1"></dx-number-box>
    </div>

    <div class="rg-calc__field">
      <label>{{ 'inventory.priceCalculation.rgForm.overhaul' | translate }}</label>
      <dx-number-box [(value)]="rgFormData.overhaul_factor"
                     format="#0.#"
                     [min]="0"
                     [step]="0.1"></dx-number-box>
    </div>

    <div class="rg-calc__field">
      <label>{{ 'inventory.priceCalculation.rgForm.workQuality' | translate }}</label>
      <dx-number-box [(value)]="rgFormData.work_quality_factor"
                     format="#0.#"
                     [min]="0"
                     [step]="0.1"></dx-number-box>
    </div>
  </div>

  <dx-button type="default"
             stylingMode="contained"
             icon="money"
             [text]="'inventory.priceCalculation.rgForm.calculate' | translate"
             [disabled]="!loaded || isCalculatingRg || !isRgFormComplete()"
             (onClick)="calcRg()"></dx-button>
</div>

<dx-data-grid [dataSource]="priceHistory"
              [showBorders]="true"
              [columnAutoWidth]="true"
              [noDataText]="'inventory.priceCalculation.noData' | translate">
  <dxo-master-detail [enabled]="true"
                     template="detail"></dxo-master-detail>

  <dxi-column dataField="price_crawled_at"
              dataType="datetime"
              [caption]="'inventory.priceCalculation.crawledAt' | translate"
              format="dd.MM.yyyy HH:mm"></dxi-column>

  <dxi-column dataField="price_origin"
              [caption]="'inventory.priceCalculation.origin' | translate"></dxi-column>

  <dxi-column [caption]="'inventory.priceCalculation.brandType' | translate"
              [allowSorting]="false"
              cellTemplate="brandTypeCell"></dxi-column>

  <dxi-column dataField="price"
              dataType="number"
              [caption]="'inventory.priceCalculation.price' | translate"
              alignment="right"
              cellTemplate="priceCell"></dxi-column>

  <dxi-column dataField="price_is_netto"
              dataType="boolean"
              [caption]="'inventory.priceCalculation.netto' | translate"
              cellTemplate="nettoCell"></dxi-column>

  <dxi-column *ngIf="canApply()"
              [caption]="'inventory.priceCalculation.apply' | translate"
              [allowSorting]="false"
              [allowFiltering]="false"
              cellTemplate="applyCell"></dxi-column>

  <div *dxTemplate="let cell of 'brandTypeCell'">
    <ng-container *ngIf="cell.data.details?.['brand'] || cell.data.details?.['type']; else titleLabel">
      {{ cell.data.details?.['brand'] || '–' }} /
      {{ cell.data.details?.['type'] || '–' }}
    </ng-container>
    <ng-template #titleLabel>{{ cell.data.details?.['title'] || '–' }}</ng-template>
  </div>

  <div *dxTemplate="let cell of 'priceCell'">
    <ng-container *ngIf="cell.data.price !== null && cell.data.price !== undefined; else noPrice">
      {{ $any(cell.data.price) | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}
    </ng-container>
    <ng-template #noPrice>–</ng-template>
  </div>

  <div *dxTemplate="let cell of 'nettoCell'">
    <ng-container *ngIf="cell.data.price !== null && cell.data.price !== undefined; else noNetto">
      {{ (cell.data.price_is_netto ? 'common.yes' : 'common.no') | translate }}
    </ng-container>
    <ng-template #noNetto>–</ng-template>
  </div>

  <div *dxTemplate="let cell of 'applyCell'">
    <dx-button *ngIf="cell.data.price !== null && cell.data.price !== undefined"
               [type]="cell.data.id === appliedHistoryId ? 'success' : 'normal'"
               [stylingMode]="cell.data.id === appliedHistoryId ? 'contained' : 'text'"
               icon="check"
               [text]="(cell.data.id === appliedHistoryId ? 'inventory.priceCalculation.appliedMark' : 'inventory.priceCalculation.apply') | translate"
               [hint]="(cell.data.id === appliedHistoryId ? 'inventory.priceCalculation.appliedMarkHint' : 'inventory.priceCalculation.applyHint') | translate"
               [disabled]="cell.data.id === appliedHistoryId || !loaded || isApplying"
               (onClick)="applyHistory(cell.data)"></dx-button>
  </div>

  <div *dxTemplate="let entry of 'detail'">
    <app-inventory-price-detail
      [details]="entry.data.details"></app-inventory-price-detail>
  </div>
</dx-data-grid>
